import { LoadState } from '@ally/use-data-domain';
import { getAllErrors, getDataLoadState } from './selectors';
var getOutage = function (accountLOB) {
    return function (hostData) {
        var loadState = getDataLoadState(hostData);
        var hasReqLoaded = loadState === LoadState.LOADED;
        var hasReqFailed = loadState === LoadState.FAILED;
        var allErrors = getAllErrors(hostData) || [];
        var hasFullOutage = hasReqLoaded &&
            allErrors.some(function (_a) {
                var code = _a.code;
                return [
                    accountLOB + "_FAILURE",
                    'CCAPI_AAA_FAILURE',
                    'CONSUMER_FAILURE',
                ].includes(String(code).toUpperCase());
            });
        var hasPartialOutage = hasReqLoaded &&
            allErrors.some(function (_a) {
                var code = _a.code;
                return String(code).toUpperCase() === accountLOB + "_PARTIAL_FAILURE";
            });
        if (hasReqFailed || hasFullOutage) {
            return 'full';
        }
        if (hasPartialOutage) {
            return 'partial';
        }
        return 'none';
    };
};
export var getAutoOutage = getOutage('AUTO');
export var getDepositOutage = getOutage('DEPOSIT');
export var getHomeLoanOutage = getOutage('HOMELOAN');
export var getInvestOutage = getOutage('INVEST');
export var getWealthOutage = getOutage('WEALTH');
export var getMortgageOutage = getOutage('MORTGAGE');
export var getCreditCardOutage = getOutage('CREDITCARD');
export var getOutages = function (hostData) {
    return {
        AUTO: getAutoOutage(hostData),
        DEPOSIT: getDepositOutage(hostData),
        HOMELOAN: getHomeLoanOutage(hostData),
        INVEST: getInvestOutage(hostData),
        WEALTH: getWealthOutage(hostData),
        MORTGAGE: getMortgageOutage(hostData),
        CC: getCreditCardOutage(hostData),
    };
};
//# sourceMappingURL=outage.js.map